import { FONT_WEIGHT } from '@app/styles/themes/constants';
import { Modal as AntModal } from 'antd';
import styled from 'styled-components';

export const Modal = styled(AntModal)`
  .ant-modal-wrap {
  }

  &.dealRoomInviteModal {
    max-width: 430px;
    margin-block: 0;
    height: 100%;
    display: flex;
    top: 0;
    align-items: flex-start;
    width: 100% !important;
    justify-content: center;

    .ant-modal-content {
      background: transparent;
      width: 100% !important;
      max-width: 100%;
      border-radius: 0;
      box-shadow: none;
      padding-block-end: 50px;
    }

    .ant-modal-close-x {
      span {
        color: #1b2449;
        font-size: 14px;
      }
    }

    .ant-modal-header {
      padding: 0;
      border: none;
      background: transparent;
    }

    .ant-modal-body {
      background: #ffffff;
      border-radius: 16px;
      width: 100% !important;
      padding: 0 20px 1px;
      box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08),
        0 9px 28px 8px rgba(0, 0, 0, 0.05);
    }

    #dealRoomInviteForm {
      padding-block-start: 20px;
    }

    .ant-modal-footer {
      display: none;
    }

    .ant-modal-title {
      color: #1a295a;
      font-size: 22px;
      font-weight: bold;
      line-height: normal;
    }
    .ant-form-vertical .ant-form-item-label > label,
    .ant-form-item-required {
      color: #1a295a;
      font-size: 22px;
      font-weight: ${FONT_WEIGHT.regular};
    }

    .ant-form-item {
      margin-bottom: 10px;
    }

    .ant-input[disabled] {
      background-color: #f5f5f5;
      border-color: #dfe2e6;
    }

    .ant-input {
      border-color: #dfe2e6;
      color: #1a295a;
      font-size: 18px;
      font-weight: ${FONT_WEIGHT.light};
    }
  }

  @media (max-width: 768px) {
    &.dealRoomInviteModal {
      max-width: 100%;
      padding-inline: 10px;
      height: auto;
      margin-block: 15px;

      .ant-modal-close-x {
        display: none;
      }

      .ant-modal-body {
        padding: 15px;
      }

      .ant-modal-title {
        font-size: 18px;
      }

      .ant-form-vertical .ant-form-item-label > label,
      .ant-form-item-required {
        font-size: 18px;
      }

      .ant-input {
        font-size: 15px;
      }
    }
  }
`;
